"use client"

import { motion } from "framer-motion"
import { User } from "lucide-react"
import { getAccountData } from "@/context/getAccountData"

export default function ChatItem({ chat, isActive, onSelect }) {
  const accountData = getAccountData()
  
  // Debug the chat item data


  const isSameUser = accountData?._id === chat.userId  // Compara el ID del usuario en la cookie con el ID del chat

  return (
    <motion.div
      className={`p-4 border-b border-gray-200 cursor-pointer ${isActive ? "bg-blue-50" : "hover:bg-gray-50"}`}
      onClick={onSelect}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
    >
      <div className="flex items-center">
        <div className="relative">
          {chat.avatar ? (
            <img
              src={chat.avatar || "/placeholder.svg?height=48&width=48"}
              alt={chat.contactName}
              className="w-12 h-12 rounded-full object-cover"
            />
          ) : (
            <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center">
              <User className="w-6 h-6 text-gray-600" />
            </div>
          )}
          {!isSameUser && chat.unreadMessagesCount > 0 && ( // Solo muestra la burbuja si el usuario no es el mismo
            <motion.div
              className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 500, damping: 30 }}
            >
              {chat.unreadMessagesCount}
            </motion.div>
          )}
        </div>
        <div className="ml-4 flex-1">
          <div className="flex justify-between items-center">
            <h2 className="font-semibold text-gray-800">{chat.contactName || "Usuario"}</h2>
            <span className="text-xs text-gray-500">
              {chat.lastMessageTime &&
                new Date(chat.lastMessageTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
            </span>
          </div>
          <p className="text-sm text-gray-600 truncate">
            {isSameUser ? `Tu: ${chat.lastMessage || "No hay mensajes"}` : chat.lastMessage || "No hay mensajes"}
          </p>
        </div>
      </div>
    </motion.div>
  )
}
